const STEP2_COPY = {
  header: {
    title: '📊 Vos résultats',
    description: 'Comparez votre revenu net selon différents statuts juridiques',
    disclaimer: 'Ces résultats sont des estimations basées sur les taux et barèmes de l’URSSAF et des organismes sociaux en vigueur. Ils peuvent comporter des approximations et ne constituent pas un engagement contractuel. Pour des informations précises et personnalisées, prenez contact avec notre équipe.',
  },
  selector: {
    label: 'Comparer avec :',
  },
  statuses: [
    { id: 'micro', label: 'Micro-entreprise', icon: '📱' },
    { id: 'ei', label: 'EI / EURL', icon: '👤' },
    { id: 'sasu', label: 'SASU', icon: '🏢' },
  ],
  cards: {
    cae: {
      title: 'CAE — SALARIÉ·E',
      protectionTitle: '✅ Protection sociale complète',
      protectionSubtitle: 'Chômage · Retraite · Maladie / Accident de Travail / Maladie professionnelle',
      accompagnementTitle: '✅ Accompagnement à l\'activité',
      collectifTitle: '✅ intégration dans un collectif d\'entrepreneur.es et un réseau de coopération',
      borderColor: 'border-primary-500',
      titleColor: 'text-primary-700',
      totalLabel: 'Montant total versé',
      totalSub: '(salaire net + frais récupérés)',
    },
    micro: {
      title: 'MICRO-ENTREPRISE',
      borderColor: 'border-blue-300',
      seuilsNote:
        'Ce simulateur retient l\'hypothèse la plus courante (prestation de services) ; votre situation réelle peut différer.',
      chargesInfoLabel: 'Charges non déductibles (pour info) :',
      availableLabel: 'Montant total disponible',
      availableSub: '(après paiement des charges)',
      incompatibleTitle: 'Simulation non calculée',
      incompatibleBody:
        'Vigilance sur le franchissement du seuil de franchise de TVA. \nAu-delà de ce seuil, vous êtes tenu·e de facturer la TVA à vos clients et de la reverser.',
      incompatibleLinkPrefix: 'Pour en savoir plus : ',
      incompatibleLinkUrl: 'https://mon-entreprise.urssaf.fr',
      incompatibleLinkLabel: 'mon-entreprise.urssaf.fr',
      incompatibleAdvice: 'Comparez les statuts CAE, EI/EURL ou SASU — mieux adaptés à votre niveau d\'activité.',
    },
    sasu: {
      title: 'SASU',
      borderColor: 'border-indigo-300',
    },
    ei: {
      title: 'EI / EURL',
      borderColor: 'border-purple-300',
    },
  },
  details: {
    autresChargesTitle: '📋 Autres frais de structure',
    autresChargesSubtitle: 'Montants saisis ou minima appliqués (mensuel)',
    caeParticipationTitle: '📋 Frais de participation coopérative — détail',
    caeNetTitle: '📋 Charges forfaitaires',
    unitReminder: 'Tous les montants affichés sont mensuels.',
  },
  navigation: {
    previous: 'Retour',
    next: '➡️ Comparer la protection sociale',
    print: '🖨️ Imprimer les résultats',
  },
};

export default STEP2_COPY;
